<template>
  <div class="login-land">
    <p class="login-land-p-One">{{$t('i.system.examinationSystem')}}</p>
    <p class="login-land-p-Two">{{userInfo.curOrgName}}</p>
    <div class="info-wrap">
      <div class="login-name">{{userInfo.curUserName}}</div>
      <div class="domainBox">
        <div class="domainText">{{$t('i.personalInformation.domain')}}:</div>
        <div class="domain">
            <Select v-model="domain" @on-change="domainChange">
              <Option v-for="(domain,index) in domains"
                      :key="domain.entry_code" :value="domain.entry_code">{{ domain.entry_name }}</Option>
            </Select>
        </div>
      </div>
    </div>

    <div class="login-buttons1">
      <div class="personal">
        <Button type="info" @click="lookPersonInfo" style="padding: 0;">{{$t('i.login.PersonalInformation')}}</Button>
      </div>
      <div class="records">
        <Button type="info" @click="$router.push({name:'resume'})">{{$t('i.system.examinationRecords')}}</Button>
      </div>
    </div>
    <div class="personalInformationPopup" v-show="flag">
      <personal-information @close="()=>flag = false" :personalInformation="personalInformation"></personal-information>
    </div>
    <div class="login-buttons2">
      <div v-if="userInfo.isManage == '1'" class="administration">
        <Button type="info" @click="toConsoleHome">{{$t('i.system.administration')}}</Button>
      </div>
      <div class="sign-out">
        <Button type="info" @click="frontLogout">{{$t('i.system.signOut')}}</Button>
      </div>
    </div>
  </div>
</template>

<script>
  import personalInformation from '../../personalInformation/personalInformation'
  export default {
    name: "system",
    components:{
      personalInformation
    },
    data(){
      let userInfo = localStorage.getItem("userInfo");
      if(userInfo){
        userInfo = JSON.parse(userInfo);
      }else{
        userInfo = {
          curRole: '',
          isManage: '0',
          roles: [],
          curUserName: '',
          curOrgName: '',
          curUserLoginId: '',
          curJsSessionId: '',
        };
      }
      return{
        domains: [],
        domain: localStorage.getItem('domain'),
        flag: false,
        personalInformation:'',
        userInfo: userInfo,
      }
    },
    methods: {
      async frontLogout(){
        await this.RequestUtil.request("/frontLogout");
        await localStorage.removeItem("userInfo");
        await localStorage.removeItem("domain");
        this.$router.push({name:'login'})
        // this.$router.replace({name:'login'})
        location.reload()
        // window.location.href = '/'
        // await this.$emit('setLoginCheck', '0');
      },
      async domainChange(value) {
        localStorage.setItem('domain', value)
        const json = await this.RequestUtil.request("/front/train/noReadNum")
        if (json && json.datas) {
          this.$store.commit('setNoReadNum',json.datas.num)
        }
        this.visitorIndex()
        await this.$router.push('/index/')
      },
      async visitorIndex(){
        const json = await this.RequestUtil.request("/visitorIndex");
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            this.$store.commit('setLatestNews', json.datas.news)
          }
        }
      },
      async getDomainList(){
        const json = await this.RequestUtil.request("/companyList?code=SSLY");
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.domains = json.datas;
          }
        }
      },
      async lookPersonInfo(){
        this.flag = true;
        const json = await this.RequestUtil.request("/front/person");
        if(json){
          if(json.statusCode == this.Constants.statusCode.ok){
            this.personalInformation = json.datas.user;
          }
        }
      },
      toConsoleHome(){
        let defaultLangValue = localStorage.getItem("defaultLangValue");
        if(!defaultLangValue){
          defaultLangValue = "zh_CN";
        }
        window.location.href = this.Constants.serverURL + "/consoleHome?curJsSessionId=" + localStorage.getItem("curJsSessionId") + '&language=' + defaultLangValue;
      }
    },
    created() {
      this.getDomainList();
    }
  }
</script>

<style scoped>
  >>> .ivu-select-single .ivu-select-selection{
    height: 30px;
  }
  .info-wrap{
    display: flex;
    padding: 0 10px;
    font-size: 14px;
    margin-bottom: 5px;
  }
  .domainBox {
    height: 30px;
    display: flex;
    line-height: 30px;
  }
  .domain{
    /* flex: 1; */
    width: 100px;
    margin-left: 5px;
  }
  .domainText {
    height: 30px;
    line-height: 30px;
    text-align: right;
    width: 50px;
    text-align: right;
  }
  .login-land{
    width: 288px;
    height: 210px;
    float: left;
    border: 2px solid #384a4d;
    margin-top: 80px;
    border-radius: 10px;
  }

  .login-land-p-One{
    font-size: 18px;
    color: #4e4e4e;
    text-align: center;
    margin-top: 10px;
  }

  .login-land-p-Two{
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
  }
  .login-name{
    width: 40%;
    height: 30px;
    /* text-align: center; */
    /* margin: 0 auto; */
    line-height: 30px;
  }
  .login-buttons1{
    width: 250px;
    height: 25px;
    margin: 0 auto;
  }
  .personal{
    width: 125px;
    height: 25px;
    float: left;
  }
  .records{
    width: 125px;
    height: 25px;
    float: left;
  }
  .personalInformationPopup{
    position: absolute;
    z-index: 110;
    background-color: #fff;
  }
  .login-buttons1 button{
    width: 80px;
    height: 25px;
    line-height: 15px;
    margin-left: 18px;
  }

  .login-buttons2{
    width: 250px;
    height: 25px;
    margin: 20px auto;
  }
  .administration{
    width: 125px;
    height: 25px;
    float: left;
  }
  .sign-out{
    width: 125px;
    height: 25px;
    float: left;
  }
  .login-buttons2 button{
    width: 80px;
    height: 25px;
    margin-left: 18px;
    line-height: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/system/components/system.vue